/**
 * Calculates horizontal field of view from aspect ratio and vertical field of view
 * @param {Object} args - Object to be deconstructed which contains arguments.
 * @param {Number} args.aspectRatio
 * @param {Number} args.verticalFieldOfView
 * @return {Number}
 */

export default function calculateHorizontalFieldOfViewFromVerticalFieldOfView({ aspectRatio, verticalFieldOfView }) {
  return verticalFieldOfView * aspectRatio
}



// WEBPACK FOOTER //
// ./src/helpers/calculations/calculateHorizontalFieldOfViewFromVerticalFieldOfView.js